module.exports = __webpack_public_path__ + "img/csg_bg.0c5135f9.jpg";